import { Component, OnInit } from '@angular/core';
import { ToggleService } from '~/toggles/services/toggle.service';
import { ToggleNameEnum } from '~/toggles/services/toggle/enums/name.enum';

@Component({
  selector: 'app-unauthorized-access',
  templateUrl: './unauthorized-access.component.html',
  styleUrls: ['./unauthorized-access.component.scss'],
})
export class UnauthorizedAccessComponent implements OnInit {
  public countryUrl: string;
  public readonly toggleNameEnum = ToggleNameEnum;

  constructor(private readonly toggleService: ToggleService) {}

  ngOnInit(): void {
    this.countryUrl = this.toggleService
      .getVariantString(this.toggleNameEnum.CountriesWebforms, null)
      .trim();
  }
}
